import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {intlShape, FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import _ from 'lodash';

const LOCALE_PREFIX = 'DE/pages/SepaPage/SepaPage';

export class Bank extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        bankAcctNmbr: PropTypes.string.isRequired,
        bankName: PropTypes.string.isRequired,
        bankBic: PropTypes.string.isRequired,
    };

    render() {
        const { bankAcctNmbr, bankName, bankBic } = this.props;
        return (
            <div>
                <h4>
                    <FormattedMessage id={`${LOCALE_PREFIX}.IBAN`} />
                </h4>
                <span id="sepa-iban">{bankAcctNmbr}</span>

                <div className="marginTop">
                    <h4>
                        <FormattedMessage id={`${LOCALE_PREFIX}.bankName`} />
                    </h4>
                    <span>{bankName}</span>
                </div>

                <div className="marginTop">
                    <h4>
                        <FormattedMessage id={`${LOCALE_PREFIX}.bic`} />
                    </h4>
                    <span id="sepa-bic">{bankBic}</span>
                </div>
            </div>

        );
    }
}

export const mapStateToProps = state => ({
    bankAcctNmbr: _.get(state, 'serverData.decisionModel.bank.bankAcctNmbr'),
    bankName: _.get(state, 'serverData.decisionModel.bank.name'),
    bankBic: _.get(state, 'serverData.decisionModel.bank.bic')
});

export default connect(mapStateToProps)(injectIntl(Bank));
